import { Inject, Injectable } from '@angular/core';
import { TuiAlertOptions, TuiAlertService } from '@taiga-ui/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly autoCloseTimeInMs = 4000;

  constructor(
    @Inject(TuiAlertService)
    private readonly tuiAlertService: TuiAlertService,
  ) {}

  public async showErrorNotification<T = any>(
    message: string,
    options?: Partial<TuiAlertOptions<T>>,
  ): Promise<void> {
    const defaultOptions: Partial<TuiAlertOptions<T>> = {
      appearance: 'error',
      autoClose: this.autoCloseTimeInMs,
    };
    const notification$ = this.tuiAlertService.open(message, {
      ...defaultOptions,
      ...options,
    });
    await lastValueFrom(notification$, { defaultValue: undefined });
  }

  public async showInfoNotification<T = any>(
    message: string,
    options?: Partial<TuiAlertOptions<T>>,
  ): Promise<void> {
    const defaultOptions: Partial<TuiAlertOptions<T>> = {
      appearance: 'info',
      autoClose: this.autoCloseTimeInMs,
    };
    const notification$ = this.tuiAlertService.open(message, {
      ...defaultOptions,
      ...options,
    });
    await lastValueFrom(notification$, { defaultValue: undefined });
  }

  public async showSuccessNotification<T = any>(
    message: string,
    options?: Partial<TuiAlertOptions<T>>,
  ): Promise<void> {
    const defaultOptions: Partial<TuiAlertOptions<T>> = {
      appearance: 'success',
      autoClose: this.autoCloseTimeInMs,
    };
    const notification$ = this.tuiAlertService.open(message, {
      ...defaultOptions,
      ...options,
    });
    await lastValueFrom(notification$, { defaultValue: undefined });
  }

  public async showWarningNotification<T = any>(
    message: string,
    options?: Partial<TuiAlertOptions<T>>,
  ): Promise<void> {
    const defaultOptions: Partial<TuiAlertOptions<T>> = {
      appearance: 'warning',
      autoClose: this.autoCloseTimeInMs,
    };
    const notification$ = this.tuiAlertService.open(message, {
      ...defaultOptions,
      ...options,
    });
    await lastValueFrom(notification$, { defaultValue: undefined });
  }
}
